import { Panel } from "@/components";
import React, { useEffect, useState } from "react";
import OverviewCard from "./OverviewCard";
import { observer } from "mobx-react-lite";
import ShopInfoStore, { ShopInfoStoreContext } from "./store";
import { useGlobalStore } from "@/store/hooks";

import TotalInfoCard from "./TotalInfoCard";
import "./index.less";

interface ShopInfoCardProps {
    isSupplier?: boolean;
}

const ShopInfoCard: React.FC<ShopInfoCardProps> = function (props) {
    const { isSupplier } = props;

    const globalStore = useGlobalStore();
    const [store] = useState(() => new ShopInfoStore(globalStore));

    useEffect(() => {
        store.load();
    }, []);

    return (
        <ShopInfoStoreContext.Provider value={store}>
            <Panel title="店铺汇总数据" className="home-overview-container" noBorder>
                <TotalInfoCard />
            </Panel>

            <OverviewCard isSupplier={isSupplier} />
        </ShopInfoStoreContext.Provider>
    );
};

export default observer(ShopInfoCard);
